<template>
  <div class="container">
    <div ref="switch" class="switch-buttons is-hidden-desktop">
      <button
        class="button"
        v-if="activeColumn === 'first'"
        @click="showColumn('second')"
      >
        {{ switchToSecondButton }}
      </button>
      <button class="button" v-else @click="showColumn('first')">
        {{ switchToFirstButton }}
      </button>
    </div>

    <div class="columns is-mobile two-columns">
      <div
        class="column first-column is-full-mobile is-full-tablet is-5-desktop"
        :class="{ 'is-hidden-touch': activeColumn === 'second' }"
      >
        <div class="header"><slot name="first-column-header" /></div>
        <div class="body"><slot name="first-column-body" /></div>
      </div>
      <div
        class="column second-column is-full-mobile is-full-tablet is-7-desktop"
        :class="{ 'is-hidden-touch': activeColumn === 'first' }"
      >
        <div class="header"><slot name="second-column-header" /></div>
        <div class="body"><slot name="second-column-body" /></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "two-column",
  props: ["switchToFirstButton", "switchToSecondButton"],
  data() {
    return {
      isDesktop: true,
      activeColumn: "first"
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    showColumn(column) {
      this.activeColumn = column
    },
    handleResize() {
      const style = window.getComputedStyle(this.$refs.switch)
      this.isDesktop = style.display === "none"
      this.$emit("resize", this.isDesktop)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.two-columns {
  @include desktop {
    .first-column {
      height: calc(100vh - 3.25rem);
      position: sticky;
      top: 3.25em;
      display: flex;
      flex-direction: column;
      .body {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }
    }
    .second-column {
      min-height: calc(100vh - 3.25rem);
      display: flex;
      flex-direction: column;
      .body {
        flex: 1;
      }
    }
  }
}
.switch-buttons {
  margin-bottom: 0.75rem;
}
</style>
